module.exports = __webpack_public_path__ + "static/media/rule-three@2x.b843c254.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/rule-three@2x.png
// module id = 1693
// module chunks = 0